export default __webpack_public_path__ + "static/media/Dl2Ixn.e3b80287.jpg";